

























import BaseVue from "../../core/BaseVue";
import User from "../../models/security/user.model";
import UserService from "@/services/user.service";
import GenericBTable from "../../core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import Base from "../../models/base/Base.model";
import ProposalsPrioritization from "@/components/proposalsPrioritization/proposalsPrioritization.vue";
import { Component } from "vue-property-decorator";
import Vue from "vue";
import { ProposalState } from "@/enums/ProposalState";
import PorposalService from "../../services/porposal.service";
import Porposal from "../../models/porposal/porposal.model";
import { EvaluationState } from "@/enums/EvaluationState";
@Component({
  components: {
    ProposalsPrioritization
  }
})
export default class ProposalPrioritization extends Vue {
  recomendada: EvaluationState = EvaluationState.RECOMENDADA;
  noRecomendada: EvaluationState = EvaluationState.NORECOMENDADA;
  recomendadaCondiciones: EvaluationState =
    EvaluationState.RECOMENDADACONCONDICION;

  constructor() {
    super();
  }
  created() {}
}
